import { createStrings } from '@utils/local';
import dayjs from 'dayjs';

export const calendarStrings = createStrings({
  ja: {
    weekdaysShort: (i: number) => ['日', '月', '火', '水', '木', '金', '土'][i],
    days: (i: number) => `${i}日`,
    months: (i: number) => `${i}月`,
    yearMonth: (d: Date) => dayjs(d).format('YYYY年M月'),
    yearMonthDay: (d: Date) => `${dayjs(d).format('YYYY年M月D日')}`,
    yearMonthDayWeekday: (d: Date) =>
      `${calendarStrings.yearMonthDay(d)}(${calendarStrings.weekdaysShort(d.getDay())})`,
  },
});
